import type { AvailableSelectionsView } from '@/api/custom-bets';

type Listener = () => void;

/**
 * Last calculate-filter `AvailableSelections` for conflict disabling in the BB UI.
 * Module-level so EventDetails and the pricing hook share one snapshot.
 */
let availableSelections: AvailableSelectionsView[] | null = null;
let calcSeq = 0;
const listeners = new Set<Listener>();

function notify(): void {
  for (const listener of listeners) listener();
}

export function subscribeCustomBetAvailability(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getCustomBetAvailableSelections(): AvailableSelectionsView[] | null {
  return availableSelections;
}

export function setCustomBetAvailableSelections(
  next: AvailableSelectionsView[] | null,
): void {
  availableSelections = next;
  notify();
}

export function clearCustomBetAvailableSelections(): void {
  if (availableSelections == null) return;
  availableSelections = null;
  notify();
}

/** Monotonic seq for ignoring stale calculate-filter responses (legacy `CalcSeq`). */
export function nextCustomBetCalcSeq(): number {
  calcSeq += 1;
  return calcSeq;
}

export function getCustomBetCalcSeq(): number {
  return calcSeq;
}

export function __resetCustomBetAvailabilityForTests(): void {
  availableSelections = null;
  calcSeq = 0;
  notify();
}
